// third party
import * as yup from 'yup';

// project imports
import { validationSchema as phoneNumberValidationSchema } from '../../common/phone-number';

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            name: yup
                .string()
                .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
                .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
            lastName: yup
                .string()
                .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-lastname-max', values: { maxValue: 255 } }))
                .nullable(),
            job: yup
                .string()
                .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-job-max', values: { maxValue: 255 } }))
                .nullable(),
            emails: yup
                .array()
                .of(
                    yup
                        .string()
                        .email(intl.formatMessage({ id: 'ui-comp-formvalidation-email-invalid' }))
                        .lowercase()
                )
                .nullable(),
            phoneNumbers: yup.array().of(phoneNumberValidationSchema(intl)).nullable()
        })
        .test({
            name: 'checkEmailsOrPhoneNumbersAreFilled',
            message: intl.formatMessage({ id: 'ui-comp-formvalidation-contacts-emailsphonenumbers-atleastone' }),
            test: (contact) =>
                ('emails' in (contact || {}) && Array.isArray(contact.emails) && contact.emails.some((email) => email.length > 0)) ||
                ('phoneNumbers' in (contact || {}) &&
                    Array.isArray(contact.phoneNumbers) &&
                    contact.phoneNumbers.some((phoneNumber) => 'number' in (phoneNumber || {}) && phoneNumber.number.length > 0))
        })
        .nullable();

export default validationSchema;
